<div class="fdx-u-mt--7 fdx-u-mb--5 fdx-u-color--grey--dark-1">
  <h3 class="fdx-c-header fdx-c-header--h3 fdx-u-align--center">Modal</h3>
</div>
<form (submit)="buildModal()" [formGroup]="modalFormGroup" class="fdx-u-mb--5">
  <div class="fdx-o-grid__row fdx-o-grid__row--guttered-small fdx-u-mb--10">
    <div class="fdx-o-grid__item--6">
      <div class="fdx-c-form-group fdx-c-form-group--select fdx-c-form-group--asd">
        <span class="fdx-c-form-group__item">
          <select [formControl]="modalComponentControl" class="fdx-c-form-group__select" id="component">
            @for (comp of components; track comp) {
              <option [ngValue]="comp">{{comp.name}}</option>
            }
          </select>
          <span aria-hidden="true" class="fdx-c-form-group__icon">
            <ciam-icon class="fdx-c-icon" aria-hidden="true" key="chevron"></ciam-icon>
          </span>
          <label class="fdx-c-form-group__label " for="component">Component</label>
        </span>
      </div>
    </div>

    <div class="fdx-o-grid__item--6">
      <div class="fdx-c-form-group fdx-c-form-group fdx-c-form-group--float-label fdx-c-form-group--has-value">
        <div class="fdx-c-form-group__item">
          <input [formControl]="modalTitleComponent"
            class="fdx-c-form-group__input"
            id="toastMessage"
            type="text"
            placeholder="OPTIONAL">
            <label class="fdx-c-form-group__label fdx-c-form-group__label--dark" for="toastMessage">
              Title
            </label>
          </div>
        </div>
      </div>
    </div>

    <div class="fdx-u-align--center">
      <button class="fdx-c-button fdx-c-button--full-width fdx-c-button--primary fdx-c-button--responsive">
        Build Modal
      </button>
    </div>
  </form>

  <div class="fdx-u-align--center">
    <button (click)="cancelAllPoprs()" class="fdx-c-button fdx-c-button--text">
      Cancel All Poprs
    </button>
  </div>
